import { render, staticRenderFns } from "./serveContent.vue?vue&type=template&id=b9e1131c&scoped=true&"
import script from "./serveContent.vue?vue&type=script&lang=js&"
export * from "./serveContent.vue?vue&type=script&lang=js&"
import style0 from "./serveContent.vue?vue&type=style&index=0&id=b9e1131c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e1131c",
  null
  
)

export default component.exports